import { defineStore } from '@sunrise/pinia'

import { Toast } from '../../../components/MsToastManager/MsToastManager.interface'

import { createTimeoutManager } from '../../utils/timeoutUtils'
import { ToastStore } from './toastStoreModule.interface'

let id = 0
const timeoutManager = createTimeoutManager()

export const useToastStore = defineStore('toastStore', {
    state: (): ToastStore => ({
        toasts: [],
    }),
    actions: {
        addToast(toast: Toast) {
            const tempId = id++
            toast.id = tempId

            this.toasts.push(toast)

            timeoutManager.add(
                tempId,
                setTimeout(() => this.removeToast(tempId), 5000),
            )
        },
        removeToast(id: number) {
            this.toasts = this.toasts.filter((toast) => toast.id !== id)
            timeoutManager.remove(id)
        },
        startTimeout(id: number) {
            timeoutManager.add(
                id,
                setTimeout(() => this.removeToast(id), 5000),
            )
        },
        stopTimeout(id: number) {
            timeoutManager.remove(id)
        },
    },
})
